<script lang="ts">
    import { onMount } from "svelte";
    import { fade, fly } from "svelte/transition";
    import ArrowRightIcon from "../icons/ArrowRightIcon.svelte";
    import PlusIcon from "../icons/PlusIcon.svelte";
    import Btn from "./Btn.svelte";
    import IconImg from "./IconImg.svelte";
    import Cookies from "js-cookie";
    import SinusWave from "../icons/SinusWaveIcon.svelte";
    import gsap from "gsap";
    import CloseIcon from "../icons/CloseIcon.svelte";
    import { t } from "../helpers/translation";
    import MailIcon from "../icons/MailIcon.svelte";
    import PhoneIcon from "../icons/PhoneIcon.svelte";
    import id from "date-fns/locale/id";
    import Container from "./Container.svelte";
    import Subline from "./Subline.svelte";
    import Gap from "./Gap.svelte";
    import Divider from "./Divider.svelte";
    import { urlRoute } from "@roxi/routify";

    let show = false;
    let fcwrapper: HTMLDivElement = null;

    function open(): void {
        show = true;
        scrollFCWrapperTop();
    }

    function close(): void {
        show = false;
        scrollFCWrapperTop();
    }

    function scrollFCWrapperTop() {
        if (fcwrapper) {
            fcwrapper.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    }

    // @prettier-ignore
    function toggle(): void {
        if (!show) {
            switch (window.location.pathname.split("/").pop()) {
                case "leitsysteme":
                    formdata.topic = $t(
                        "modal.contact.form.field.topic.leitstellensysteme",
                    );
                    break;
                case "wachen-und-elw":
                    formdata.topic = $t(
                        "modal.contact.form.field.topic.wachen-elw",
                    );
                    break;
                case "einsatznavigation":
                    formdata.topic = $t(
                        "modal.contact.form.field.topic.einsatznavigation",
                    );
                    break;
                case "sprach-und-datenfunk":
                    formdata.topic = $t(
                        "modal.contact.form.field.topic.sprach-datenfunk",
                    );
                    break;
                case "digitale-alarmierung":
                    formdata.topic = $t(
                        "modal.contact.form.field.topic.digitale-alarmierung",
                    );
                    break;
                case "reparaturen":
                    formdata.topic = $t(
                        "modal.contact.form.field.topic.wartung-reparaturen",
                    );
                    break;
                case "it":
                    formdata.topic = $t("modal.contact.form.field.topic.it");
                    break;
            }
        }
        show = !show;

        if (!show) {
            scrollFCWrapperTop();
        }
    }

    onMount(async () => {
        // formdata.topic = topics[0];
        // formdata.gerState = "";

        window["openFCmodal"] = open;

        const getRecaptachaRenderFunc = () => window["grecaptcha"]?.render;

        const checkerInterval = setInterval(() => {
            if (typeof getRecaptachaRenderFunc() === "function") {
                clearInterval(checkerInterval);
                try {
                    getRecaptachaRenderFunc()(recaptchaRef, {
                        sitekey: "6LeTTxwUAAAAAGJQqRfoqmlEsuZCPj8uJDDsLewa",
                    });
                } catch (e) {}
            }
        }, 1000);
    });

    const sendToApi = async (): Promise<boolean> => {
        const payload = {
            ...formdata,
            gRecaptchaResponse: window["grecaptcha"]?.getResponse(),
        };
        return await fetch("/api/EmailSend", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        })
            .then((res) => {
                if (res.ok) return res.json();
                else throw new Error();
            })
            .catch((err) => {
                console.error(err);
                return false;
            });
    };

    const validateForm = async () => {
        // ... validated?
        for (const name in formfields) {
            const field = formfields[name];
            if (field.validity.valid == false) {
                field.reportValidity();
                return;
            }
        }

        form_is_sending = true;
        const success = await sendToApi();
        form_is_sending = false;
        sending_feedback_text = success
            ? $t("modal.contact.form.sendingfeedback.success")
            : $t("modal.contact.form.sendingfeedback.error");
        sending_failed = !success;

        if (!sending_failed) form.reset();
    };

    let sending_feedback_text = "";
    let sending_failed = false;
    let form_is_sending = false;

    type Form = {
        privacy: boolean;
        gender: string;
        firstName: string;
        lastName: string;
        tel: string;
        email: string;
        firmName: string;
        topic: string;
        gerState: string;
        message: string;
    };

    let formdata: Form = {
        privacy: false,
        gender: "",
        firstName: "",
        lastName: "",
        tel: "",
        email: "",
        firmName: "",
        topic: "",
        gerState: "",
        message: "",
    };

    let formfields = {
        privacy: null,
        gender: null,
        firstName: null,
        lastName: null,
        tel: null,
        email: null,
        firmName: null,
        topic: null,
        gerState: null,
        message: null,
    };

    function getTopics() {
        return [
            $t("modal.contact.form.field.topic.leitstellensysteme"),
            $t("modal.contact.form.field.topic.wachen-elw"),
            $t("modal.contact.form.field.topic.einsatznavigation"),
            $t("modal.contact.form.field.topic.sprach-datenfunk"),
            $t("modal.contact.form.field.topic.digitale-alarmierung"),
            $t("modal.contact.form.field.topic.wartung-reparaturen"),
            $t("modal.contact.form.field.topic.it"),
        ];
    }

    let topics: string[] = getTopics();
    let gerStates: string[] = [
        $t("modal.contact.form.field.bundesland.1"),
        $t("modal.contact.form.field.bundesland.2"),
        $t("modal.contact.form.field.bundesland.3"),
        $t("modal.contact.form.field.bundesland.4"),
        $t("modal.contact.form.field.bundesland.5"),
        $t("modal.contact.form.field.bundesland.6"),
        $t("modal.contact.form.field.bundesland.7"),
        $t("modal.contact.form.field.bundesland.8"),
        $t("modal.contact.form.field.bundesland.9"),
        $t("modal.contact.form.field.bundesland.10"),
        $t("modal.contact.form.field.bundesland.11"),
        $t("modal.contact.form.field.bundesland.12"),
        $t("modal.contact.form.field.bundesland.13"),
        $t("modal.contact.form.field.bundesland.14"),
        $t("modal.contact.form.field.bundesland.15"),
        $t("modal.contact.form.field.bundesland.16"),
    ];
    let genders: string[] = [
        $t("modal.contact.form.field.ansprache.1"),
        $t("modal.contact.form.field.ansprache.2"),
        $t("modal.contact.form.field.ansprache.3"),
    ];

    $: t.subscribe(() => (topics = getTopics()));

    let form: HTMLFormElement = null;
    let recaptchaRef: HTMLDivElement = null;
</script>

<div id="floating-contact-wrapper" class:show bind:this={fcwrapper}>
    <div id="floating-contact" class:show>
        <div id="fc-toggler" on:click={toggle}>
            <IconImg svg={MailIcon} />
            <IconImg svg={PhoneIcon} />
        </div>
        <div style="display: flex; justify-content: flex-end;">
            <Btn close on:click={close} small>
                {$t("modal.btn.close")}
            </Btn>
        </div>
        <Container max="700px">
            <center>
                <div
                    style="font-weight: 300; display: flex; flex-direction: column; gap: .75rem; font-size: 1.5rem;"
                >
                    <a
                        style:color="var(--grayDark2)!important"
                        href="mailto:vertrieb@sinus-nt.de"
                        >vertrieb@sinus-nt.de</a
                    >
                    <a
                        style:color="var(--grayDark2)!important"
                        href="tel:+49406828750"
                        >+49 40 682875 0
                    </a>
                </div>
            </center>
            <Divider />
            <center>
                <Gap />
                <Subline color="var(--grayDark)">
                    {@html $t("modal.contact.headline.top")}
                </Subline>
                <!-- <Gap height="1rem" /> -->
            </center>

            <Gap height="2rem" />

            <form action="post" bind:this={form}>
                <label for="topic" id="topic">
                    <span>
                        {$t("modal.contact.form.field.topic")}
                        *
                    </span>
                    <select
                        name="topic"
                        id="topic"
                        bind:value={formdata.topic}
                        bind:this={formfields.topic}
                        required
                    >
                        <option value="" checked disabled
                            >{$t("form.placeholder.select")}</option
                        >
                        {#each topics as topic}
                            <option value={topic}>{topic}</option>
                        {/each}
                    </select>
                </label>
                <label for="gender" id="gender">
                    <span>
                        {$t("modal.contact.form.field.ansprache")}
                        *
                    </span>
                    <select
                        name="gender"
                        id="gender"
                        bind:value={formdata.gender}
                        bind:this={formfields.gender}
                        required
                    >
                        <option value="" checked disabled
                            >{$t("form.placeholder.select")}</option
                        >
                        {#each genders as gender}
                            <option value={gender}>{gender}</option>
                        {/each}
                    </select>
                </label>
                <label for="firstName">
                    <span>
                        {$t("modal.contact.form.field.firstname")}
                        *
                    </span>
                    <input
                        type="text"
                        name="firstName"
                        id="firstName"
                        bind:value={formdata.firstName}
                        bind:this={formfields.firstName}
                        required
                        placeholder={$t("form.placeholder.required")}
                    />
                </label>
                <label for="lastName">
                    <span>
                        {$t("modal.contact.form.field.lastname")}
                        *
                    </span>
                    <input
                        type="text"
                        name="lastName"
                        id="lastName"
                        bind:value={formdata.lastName}
                        bind:this={formfields.lastName}
                        required
                        placeholder={$t("form.placeholder.required")}
                    />
                </label>
                <label for="firmName">
                    <span>
                        {$t("modal.contact.form.field.firmname")}
                    </span>
                    <input
                        type="text"
                        name="firmName"
                        id="firmName"
                        bind:value={formdata.firmName}
                        bind:this={formfields.firmName}
                    />
                </label>
                <label for="email">
                    <span>
                        {$t("modal.contact.form.field.email")}
                        *
                    </span>
                    <input
                        type="email"
                        name="email"
                        id="email"
                        bind:value={formdata.email}
                        bind:this={formfields.email}
                        required
                        placeholder={$t("form.placeholder.required")}
                    />
                </label>
                <label for="tel">
                    <span>
                        {$t("modal.contact.form.field.phone")}
                    </span>
                    <input
                        type="tel"
                        name="tel"
                        id="tel"
                        bind:value={formdata.tel}
                        bind:this={formfields.tel}
                    />
                </label>
                <label for="gerState" id="gerState">
                    <span>
                        {$t("modal.contact.form.field.bundesland")}
                        *
                    </span>
                    <select
                        name="gerState"
                        id="gerState"
                        required
                        bind:this={formfields.gerState}
                        bind:value={formdata.gerState}
                    >
                        <option value="" checked disabled
                            >{$t("form.placeholder.select")}</option
                        >
                        {#each gerStates as gerState}
                            <option value={gerState}>{gerState}</option>
                        {/each}
                    </select>
                </label>
                <label for="message">
                    <span>
                        {$t("modal.contact.form.field.message")}
                    </span>
                    <textarea
                        rows="7"
                        name="message"
                        id="message"
                        bind:value={formdata.message}
                        bind:this={formfields.message}
                        placeholder="..."
                    />
                </label>
                <label for="privacy">
                    <span>
                        {$t("modal.contact.form.field.privacy")}
                        *
                    </span>
                    <div
                        style="display: flex; gap: 1em; align-items: flex-start;"
                    >
                        <span style="padding-left: 0; padding-right: 0">
                            <input
                                type="checkbox"
                                name="privacy"
                                id="privacy"
                                bind:value={formdata.privacy}
                                bind:this={formfields.privacy}
                                required
                                style="transform: scale(2);"
                            />
                        </span>
                        <span
                            style="text-align: left; padding-left: 0; font-size: 14px"
                        >
                            {@html $t("modal.contact.form.field.privacytext")}
                        </span>
                    </div>
                </label>

                <Divider gap="2rem" />

                <div
                    bind:this={recaptchaRef}
                    class="g-recaptcha"
                    data-sitekey="6LeTTxwUAAAAAGJQqRfoqmlEsuZCPj8uJDDsLewa"
                ></div>

                <Divider gap="2rem" />

                <div style="min-height: 8rem; text-align: center">
                    <Btn
                        blinking={form_is_sending}
                        on:click={validateForm}
                        small={form_is_sending}
                        >{form_is_sending
                            ? $t("modal.contact.form.btn.sending")
                            : $t("modal.contact.form.btn.send")}</Btn
                    >
                    {#if sending_feedback_text}
                        <div
                            class="sending-feedback"
                            class:sending_failed
                            transition:fade
                        >
                            {sending_feedback_text}
                        </div>
                    {/if}
                </div>
            </form>

            <div style="text-align: center;">
                <Gap height="3rem" />
                <Subline color="var(--grayDark)" mb=".5em">
                    {@html $t("modal.contact.headline.bottom")}
                </Subline>
                <div
                    style="display: flex; flex-wrap: wrap; gap: 2rem; align-items: center; justify-content: center"
                >
                    <Btn
                        href="ueber-uns/niederlassungen"
                        arrow
                        yellow
                        on:click={close}
                    >
                        {@html $t("modal.contact.btn.locations")}
                    </Btn>
                </div>
            </div>
        </Container>
    </div>
</div>

<style lang="scss">
    @import "../src/vars";

    #floating-contact-wrapper {
        position: fixed;
        right: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 100;
        pointer-events: none;
        transition: 0.5s ease-in-out;
        background: transparent;
        display: flex;
        padding-top: 8rem;
        padding-bottom: 8rem;
        overflow: hidden;
        &.show {
            overflow-y: auto;
            background-color: rgba(black, 0.5);
            pointer-events: all;
        }
        #floating-contact {
            margin-left: auto;
            border-top-left-radius: 0.75em;
            border-bottom-left-radius: 0.75em;
            padding: 0.5em;
            z-index: 20;
            background: $grayLight;
            width: 100%;
            max-width: 800px;
            height: max-content;
            min-height: 300px;
            transform: translateX(100%);
            transition: 0.7s cubic-bezier(0.5, 0, 0, 1.2);
            transition: 0.7s cubic-bezier(0.5, 0, 0, 0.99);
            pointer-events: all;
            &.show {
                transform: translateX(0);
            }

            #fc-toggler {
                position: absolute;
                display: flex;
                flex-direction: column;
                gap: 0.5em;
                align-items: center;
                justify-content: center;
                top: 2rem;
                left: 0rem;
                transform: translateX(-100%);
                background: $green;
                color: white;
                font-size: clamp(1.2rem, 2.5vw, 1.6rem);
                padding: 0.66em;
                border-top-left-radius: 0.75em;
                border-bottom-left-radius: 0.75em;
                transition: 0.1s ease-in-out;
                cursor: pointer;
                &:hover {
                    background-color: green;
                }
            }

            #fc-close {
                margin-left: auto;
            }
        }
    }

    form {
        display: grid;
        place-items: center;
        label {
            font-size: 1.2rem;
            width: 100%;
            display: grid;
            grid-template-columns: 1fr 2fr;
            text-align: right;
            padding-bottom: 0.5em;
            @media (max-width: 650px) {
                grid-template-columns: 1fr;
                text-align: left;
            }
            input,
            span,
            select,
            textarea {
                padding: 0.5em 1em;
                font-size: 1em;
                min-width: 1em;
            }
            input,
            select,
            textarea {
                background-color: white;
                border: 1px solid $gray;
                outline: unset;
                border-radius: 0.5em;
            }
            input::placeholder {
                color: $grayLight;
            }
            textarea {
                resize: vertical;
            }
        }
        .sending-feedback {
            text-align: center;
            padding: 1em;
            width: auto;
            margin: 1em auto;
            color: $green;
            font-weight: 700;
            &.sending_failed {
                color: red;
            }
        }
    }
</style>
